'use strict';

var i18n = require('i18next');
var EditNat = require('actions/advancedNat/EditNat');
var FormView = require('actions/advancedNat/FormView');
var StaticView = require('actions/advancedNat/StaticView');

/**
 * Action configuration for advanced NAT
 */
module.exports = {
  title: i18n.t('groups.advancedNat'),
  Model: EditNat,
  FormView: FormView,
  TextView: StaticView,
};
